import { useState, useEffect } from "react";
import { t } from "i18next";

import { styled } from "@mui/material/styles";
import { WaiverRoles } from "../../../../../../types/enums";


import { getCookie } from "../../../../../../utils/Common";
import { removeRequestWaiver } from "../../../../../../services/network";
import CustomModal from "../../../../../../components/common/CustomModal";
import ReRequestWaiverConfirmation from "./ReRequestWaiverConfirmation";
import WaiverList from "./WaiversList";
// import PreviewIcon from "../../../../../../assets/PreviewIcon.svg";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function RequestWaiver(props: any) {
  const {
    setIsRequestPricingWaiver,
    requestedWaivers,
    currentRole,
    fetchWaivers,
    isLoading,
    setIsLoading
  } = props;
  const [isRequestor, setIsRequestor] = useState(false);
  const [showConfirmationPopup, setshowConfirmationPopup] = useState(false);
  const [resetWaiverData, setResetWaiverData] = useState(false);

useEffect(() => {
  try {
    const cookieValue = getCookie("userPermissions") ?? "[]";
    const parsed: string[] = JSON.parse(cookieValue);
    const tempIsApprover: boolean = parsed.includes(WaiverRoles?.PRICING_WAIVER_APPROVER);
    console.warn("isApprover", tempIsApprover);
    setIsRequestor(!tempIsApprover);
  } catch {
    setIsRequestor(false); // fallback if cookie is bad
  }
}, [WaiverRoles]);

  const handleRequestWaiverClick = () => {
    const isWaiverAlreadyRequested = requestedWaivers.some((waiver: any) => waiver?.data?.waiverStatus === "Requested");
    if (!isWaiverAlreadyRequested) {
      setIsRequestPricingWaiver(true);
    } else {
      setshowConfirmationPopup(true);
    }
  };

  const onConfirmationPopupClose = () => {
    setshowConfirmationPopup(false);
  };

  const confirmReRequestWaiver = async () => {
    setIsLoading(true);
    const waiverIds = requestedWaivers.map((waiver: any) => waiver._id);
    await removeRequestWaiver(waiverIds);
    await fetchWaivers();
    setIsRequestPricingWaiver(true);
    setshowConfirmationPopup(false);
    setIsLoading(false);
    setResetWaiverData(true);
  };

  return (
    <>
      {showConfirmationPopup && ( 
        <CustomModal
          open={showConfirmationPopup}
          handleClose={onConfirmationPopupClose}
          className={"saveApplication"}
        >
          <ReRequestWaiverConfirmation
            onDeleteAndCreate={confirmReRequestWaiver}
            onClose={onConfirmationPopupClose}
            isLoading={isLoading}
          />
        </CustomModal>
      )}
      <WaiverList
        {...props}
        t={t}
        isRequestor={isRequestor}
        handleRequestWaiverClick={handleRequestWaiverClick}
        resetWaiverData={resetWaiverData}
        setResetWaiverData={setResetWaiverData}
      />
      <></>
    </>
  );
}
